import React from 'react';
import Customers from './Customers';
import { connect } from 'react-redux';
import UserService from '../../services/api/User';
import { bindActionCreators } from 'redux';
import {
    fetchActiveCartData,
    fetchFairCarts,
    fetchUserData,
} from '../../actions/routines';
import PropTypes from 'prop-types';
class CustomersContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentCustomer: null,
        };
    }

    changeCustomerHandler = (customer) => {
        // Refreshing user data and the cart is not enough: the product counters
        // ("Assortiment klant") and the product list live outside this component and were
        // never refetched, so switching customer left both showing the previous customer's
        // numbers until a TOON click happened to refetch them.
        //
        // A full reload is deliberate over wiring those refetches through here — switching
        // customer is an infrequent, explicit action, and reloading cannot leave two parts of
        // the page disagreeing about which customer is active.
        //
        // It must happen after the PUT resolves: the API only reports the new currentCustomer
        // once that request has flushed.
        UserService.setCurrentCustomer(customer.id).then(() => {
            window.location.reload();
        });
    };

    render() {
        const { userDetails } = this.props;

        return (
            <Customers
                userDetails={userDetails}
                currentCustomer={
                    this.state.currentCustomer || userDetails?.current_customer
                }
                customerHandler={this.changeCustomerHandler}
            />
        );
    }
}

CustomersContainer.propTypes = {
    fetchActiveCartData: PropTypes.func,
    fetchFairCarts: PropTypes.func,
    fetchUserData: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails.data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(
            {
                fetchActiveCartData,
                fetchFairCarts,
                fetchUserData,
            },
            dispatch
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersContainer);
